/**
 * Calculates the banner index for the recommended package deal
 * @param {Object} bannerArgs - The arguments for the banner
 * @param {Array} bannerArgs.listingsNodes - The listings nodes
 * @param {string} bannerArgs.listType - The type of list
 * @param {boolean} bannerArgs.bundleDealSortTest - Whether the bundle deal sort test is enabled
 * @param {Array} bannerArgs.recommendedListings - The recommended listings
 * @param {number} bannerArgs.dynamicBannerPlacementIndex - The dynamic banner placement index
 * @returns {Array} The banner index and the placement index
 */
export const calculateBannerIndex = (bannerArgs) => {
  const { listingsNodes, listType, bundleDealSortTest, recommendedListings } = bannerArgs
  let dynamicBannerPlacementIndex = bannerArgs.dynamicBannerPlacementIndex

  const idxOfFirstAdInListing = listingsNodes.findIndex((item) => item.isSponsoredAd)

  let placementIndex
  if (listType === 'recommendedListings' && bundleDealSortTest) {
    placementIndex = listingsNodes.length
  } else if (idxOfFirstAdInListing !== -1 && idxOfFirstAdInListing <= 3) {
    placementIndex = 4
  } else {
    placementIndex = 3
  }

  let bannerIndex = null
  if (dynamicBannerPlacementIndex === 0) {
    bannerIndex = `${placementIndex}-${placementIndex + 1}`
    dynamicBannerPlacementIndex += 1
  } else if (dynamicBannerPlacementIndex === 1) {
    const recommendedSectionSize = recommendedListings.length
    const absoluteIndex = recommendedSectionSize + placementIndex
    bannerIndex = `${absoluteIndex}-${absoluteIndex + 1}`
  }

  return [bannerIndex, placementIndex, dynamicBannerPlacementIndex]
}
